import React from 'react';
import ReactDOM from 'react-dom';
import {Result} from '../../common/components/displayItems/results.jsx';

/**
 * Quiz leaderboard
 */

(function() {

	var ItemModel, ItemView, ItemList, ComponentView;

	// Player details model
	ItemModel = Backbone.Model.extend({
		parse: function(obj){
			obj.firstName = obj.firstname || obj.firstName;
			obj.lastName = obj.lastname || obj.lastName;

			if(isNaN(obj.score) || obj.score==0) obj.score = "0";
			return obj;
		}
	});

	// Player details view
	ItemView = Backbone.View.extend({
		initialize: function(o) {
			this.template = o.template;
		},
		render: function() {
			var obj = this.model.attributes;
			var _itemOpts = this.model.get('itemOpts');
			var _resultComponent = React.createElement( this.template,{
				item: obj,
				templateOpts : {
					variant : _itemOpts.variant
				},
				itemOpts : _itemOpts
			})

			var _el = document.createElement('div');
			ReactDOM.render( _resultComponent, _el);
			this.setElement( _el.children[0]);
			return this;
		}
	});

	ItemList = Backbone.Collection.extend({
		model : ItemModel,
		parse : function(response){
			return response.leaders
		}
	});

	// Parent component
	ComponentView = Backbone.View.extend({
		initialize: function() {
			// bind this to ensure scope is properly passed into the event callback.
			var boundFunction = function() {
				this.createCollection('friends');

			}.bind(this);
			_.bindAll( this, 'reload', 'createCollection', 'storeJson', 'addAll', 'addItem' );
			this.$list = $( '#xLeaderboard_' + this.el.id + ' .xContainerInner' );
			this.itemTemplate = Result;

			// Don't call straight away as model won't be ready yet
			NGX.App.Events.once('page:ready', boundFunction);

		},

		// Reload action used mainly for SPA campaigns
		reload : function(){
			log.debug("Reloading component at "+this.el.id,6);
			this.createCollection('friends');
		},

		// create a named collection within this view
		createCollection: function(name) {
			var list = this[name] = new ItemList({ el: this.$list });
			this.listenTo(list, 'reset', this.addAll);
			this.listenTo(list, 'add', this.addItem);
			this.listenTo(list,'sync',NGX.App.api.resizeParent);

			this.$list.html('');

			list.url = '/display/gamification/quizleaderboard.json';
			list.fetch({
				success: this.storeJson,
				data: {
					apikey	   : NGX.context.apikey,
					criteria   : this.model.get('sortFriendsBy') || 'points', // 'points' or 'badges'
					friends_ids: this.friendList,
					preview	   : NGX.context.isPreview,
					fbid	   : NGX.App.state.currentUser.fbid,
					cID		   : NGX.App.config.id,
					max		   : this.model.get('itemOpts')['maxItems']
				}
			});
		},

		// storeJson is used for list item sharing
		storeJson: function(collection, response) {
			this.model.set('response', response);
		},
		// build & render views for a whole collection
		addAll: function(collection) {
			this.$list.html('');
			_.each(collection.models, function(model) {
				this.addItem( model )
			}, this);

			// Probably have new items, so need to resize the iframe
			NGX.App.api.resizeParent();
		},
		// build and render an item view from its model
		addItem: function(model) {
			model.set('itemOpts',this.model.get('itemOpts'));
			var obj = {
				model: model,
				template: this.itemTemplate
			};
			this.$list.append( new ItemView( obj ).render().el );
		}
	});

	NGX.comps.push({type:'leaderboardquiz',view:ComponentView});

}());